module.exports = __webpack_public_path__ + "static/img/qiepian3.0a5ff75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qiepian3.png
// module id = Jme4
// module chunks = 2